import { MAX_POST_MEDIA } from "./mediaConstants";

// Legacy constant - use MAX_POST_MEDIA from mediaConstants instead
export const MAX_POST_IMAGES = 10;

// Export the new media constant for backward compatibility
export { MAX_POST_MEDIA };
